import { filterVisibleItems } from '../../../../utils/common'
import { getChartValueShare } from '../../../Chart'
import { formatBirdviewNumber } from '../../DashboardBirdview.utils.charts'

export function getBirdviewAgingChartTooltipRows({ bucket, label, t, total }) {
  const { cumulative, minDays } = bucket.payload

  return filterVisibleItems([
    {
      id: label,
      isVisible: true,
      value: t('DashboardBirdview.AgingTooltipRowKey', {
        count: formatBirdviewNumber(bucket.value),
        share: getChartValueShare(bucket.value, total),
      }),
    },
    {
      id: minDays,
      isVisible: Boolean(cumulative),
      value: t('DashboardBirdview.AgingTooltipCumulativeKey', {
        count: formatBirdviewNumber(cumulative),
        min: minDays,
      }),
    },
  ])
}
